export const SCHEDULING_USERS = 'SCHEDULING_USERS'
export const UKG_ACCOUNT_LIST = 'UKG_ACCOUNT_LIST'
export const UKG_CREDENTIALS_DATA = 'UKG_CREDENTIALS_DATA'
export const UKG_SCHEDULING_DATA = 'UKG_SCHEDULING_DATA'
export const SCHEDULERS_DATA = 'SCHEDULERS_DATA'
export const GET_HOTEL_LOCATIONS = 'GET_HOTEL_LOCATIONS'
export const SET_STATE = 'SET_STATE'
export const CLEAR_DATA = 'CLEAR_DATA'
